var render = function (_h,_vm) {var _c=_vm._c;return _c('EbxEventButton',{staticClass:"ebx-clear-filters",class:[].concat(_vm.data.staticClass, _vm.data.class),attrs:{"label":_vm.props.title,"event":_vm.parent.$x.events.ClearFacetsFilters,"data":_vm.props.facets}},[_c('template',{slot:"icon"},[_vm._t("icon")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }